import { useRef, useState } from 'react';
import { useChat } from '@ai-sdk/react';
import { dispatchDataPart } from './extensions';
import { createRunStore, runStateFromMessages } from './run-store';
/**
 * `useChat` bound to a Relay stream: every `data-*` part is reduced into a run store (runs, the
 * agent tree, handoffs, guardrails, suspensions) and then handed to the host's extensions. Hosts
 * draw their own chat on top; the run store is what a debug panel reads.
 */
export function useRelayChat(options) {
    const { transport, messages, extensions, onData, store: providedStore, ...rest } = options;
    const [ownStore] = useState(() => createRunStore(messages ? runStateFromMessages(messages) : {}));
    const store = providedStore ?? ownStore;
    // Read at dispatch time: hosts pass inline arrays, and a new array must not rebuild the chat.
    const extensionsRef = useRef(extensions ?? []);
    extensionsRef.current = extensions ?? [];
    const storeRef = useRef(store);
    storeRef.current = store;
    const onDataRef = useRef(onData);
    onDataRef.current = onData;
    const chat = useChat({
        ...rest,
        transport,
        ...(messages ? { messages } : {}),
        onData: (part) => {
            dispatchDataPart(storeRef.current, extensionsRef.current, part);
            onDataRef.current?.(part);
        },
    });
    return { ...chat, runStore: store };
}
